import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function AuthenticationActionHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!navigate) return;

    const urlParams = new URLSearchParams(window.location.search);
    const mode = urlParams.get('mode');
    // Prepare URL parameters to append during navigation
    const params = urlParams.toString();

    switch (mode) {
      case 'resetPassword':
        navigate(`/reset-password?${params}`, { replace: true });
        break;
      default:
        navigate(`/error?${params}`, { replace: true });
        break;
    }
  }, [navigate]);

  return <div>Loading...</div>;
}
